/**
 * Shared TanStack Query client.
 *
 * Defaults are tuned for an internal app that changes infrequently:
 *   - staleTime 1 min so navigating between pages doesn't refetch constantly
 *   - no auto-refetch on window focus (more startling than helpful)
 *   - no retries on 401/403 — the Next.js middleware redirects to /login
 *     for those, so retrying just delays the redirect
 */

import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      gcTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const status = (error as { status?: number } | undefined)?.status;
        if (status === 401 || status === 403) {
          return false;
        }
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
